export const buildGatewayHost = (path: string, port?: string) => {
  const portPart = port && port !== '80' ? `:${port}` : ''
  return `${path}${portPart}`
}
